import React, { useState, useEffect } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, Stack } from '@mui/material';

export interface DividendFormValues {
  date: string;
  grossAmount: number | '';
  taxPaid: number | '';
  amount: number | '';
}

interface DividendFormProps {
  open: boolean;
  initialValues?: DividendFormValues;
  onClose: () => void;
  onSubmit: (values: DividendFormValues) => void;
}

export default function DividendForm({ open, initialValues, onClose, onSubmit }: DividendFormProps) {
  const [values, setValues] = useState<DividendFormValues>(
    initialValues || { date: '', grossAmount: '', taxPaid: '', amount: '' }
  );

  // Update form values when initialValues changes
  useEffect(() => {
    if (initialValues) {
      setValues(initialValues);
    } else {
      setValues({ date: '', grossAmount: '', taxPaid: '', amount: '' });
    }
  }, [initialValues]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setValues({
      ...values,
      [name]: name === 'grossAmount' || name === 'taxPaid' || name === 'amount' ? (value === '' ? '' : Number(value)) : value
    });
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSubmit({ ...values });
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>{initialValues ? 'Editar dividendo' : 'Adicionar dividendo'}</DialogTitle>
      <form onSubmit={handleSubmit}>
        <DialogContent>
          <Stack spacing={2}>
            <TextField
              label="Data"
              name="date"
              type="date"
              value={values.date}
              onChange={handleChange}
              fullWidth
              InputLabelProps={{ shrink: true }}
              required
            />
            <TextField
              label="Valor bruto"
              name="grossAmount"
              type="number"
              value={values.grossAmount}
              onChange={handleChange}
              fullWidth
              required
            />
            <TextField
              label="Imposto pago"
              name="taxPaid"
              type="number"
              value={values.taxPaid}
              onChange={handleChange}
              fullWidth
              required
            />
            <TextField
              label="Valor"
              name="amount"
              type="number"
              value={values.amount}
              onChange={handleChange}
              fullWidth
              required
            />
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose}>Cancelar</Button>
          <Button type="submit" variant="contained">{initialValues ? 'Atualizar' : 'Adicionar'}</Button>
        </DialogActions>
      </form>
    </Dialog>
  );
}
